import { AudioLines } from 'lucide-react';
import { useParams } from 'react-router-dom';

import { HealthCheckList } from '@/components/health/HealthCheckList';
import { HealthRowActions } from '@/components/health/HealthRowActions';
import { useHealthCheck } from '@/hooks/useHealthCheck';

/**
 * Tour-scoped "Descriptions & Voiceovers" health view. Surfaces every
 * description and voiceover that needs writing or regenerating across the
 * tour's attractions, themes, and translations.
 */
export function TourHealthContentTab() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useHealthCheck('tour', 'content', id);

  return (
    <HealthCheckList
      data={data?.data}
      isLoading={isLoading}
      IconAllClear={AudioLines}
      allClearTitle="All descriptions and voiceovers ready"
      allClearDescription="Every primary, theme, and translation has a description and an in-sync voiceover."
      emptyTitle="No content to check"
      emptyDescription="Add attractions to this tour to surface description and voiceover gaps here."
      renderRowActions={(row) => <HealthRowActions row={row} />}
    />
  );
}
